export function HelpPage() {
  return (
    <div className="p-6">
      <p className="text-muted-foreground">
        Help and support will go here. This is a placeholder page.
      </p>
    </div>
  );
}
